import { useState, useEffect } from 'react'
import MaskedInput from 'react-text-mask'
import { makeTelMask, isDateValid } from './common'
import Modal from 'react-modal'
import moment from 'moment'
import MandatoryField from './MandatoryField'
// import { history } from './history'


const canSubmit = (data) => {
  // console.log('Checking can submit', data)
  let result =
    !!data.nome && data.nome.trim() !== '' &&
    !!data.rg && data.rg.trim() !== '' && data.rg !== 'NaN' &&
    !!data.nasc && data.nasc.trim() !== '' && isDateValid(data.nasc) &&
    !!data.email && data.email.trim() !== '' &&
    !!data.tel && data.tel.trim() !== '' &&
    data.tel
      .replace(/[_]/g, '')
      .replace(/[ ]/g, '')
      .replace(/[(]/g, '')
      .replace(/[)]/g, '')
      .replace(/[-]/g, '')
      .length > 9
  // console.log('Will return', result)
  return result
}

const FormPage1 = (props) => {
  // console.log('Page 1 here')
  const [valid, setValid] = useState(false)
  const [showContactDialog, setShowContactDialog] = useState(false)
  const data = props.formData

  useEffect(() => {
    console.log('useEffect here, contatoNome is', data.contatoEmergenciaNome)
    if (data.nome && !data.contatoEmergenciaNome) {
      console.log('Will show dialog')
      setShowContactDialog(true)
    }

  }, [])


  setTimeout(() => setValid(canSubmit(data), 1))
  return (

    <>
      <Modal
        isOpen={showContactDialog}
        closeTimeoutMS={300}
        onRequestClose={() => setShowContactDialog(false)}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}

        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          content: {
            position: 'unset',
            border: 'none',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '16px',
            paddingBottom: '32px',
            maxHeight: '50%',
            height: '250px',
            width: '300px',
            // width: 'max(300px, 75%)',
            maxWidth: '75%',

            // marginRight: '15%', 
            // marginLeft: '10%',
            // minWidth: '250px',
            // maxWidth: '30%', 

            // top: '25%',
            // margin: '40%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxShadow: '3px 3px rgba(0,0,0,0.5)',
          }
        }}
      >
        <div className="form-header" style={{ textAlign: 'center' }}>Contato de emergência</div>
        <div style={{ flex: 1, textAlign: 'center', marginTop: '16px' }}>
          Sua segurança é muito<br />importante pra gente!<br /><br />
          Preencha um contato de<br />emergência em seu cadastro!
        </div>
        {/* <div style={{ flex: 1 }} /> */}
        <div className="form-send-row">
          <button
            // onClick={() => history.goBack()}
            // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            className="login-button"
            style={{backgroundColor: '#F41600'}}
            onClick={() => setShowContactDialog(false)}
          >OK
          </button>
        </div>
      </Modal>

      <form className="form"
        style={{
          alignItems: 'center'
        }}>

        <div className="form-header">Informações gerais</div>

        {/* Nome */}
        <div className="form-field-group">
          <MandatoryField title='Nome:' />
          <input type="text" name="nome" className="form-text"
            value={data.nome ? data.nome : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   nome: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ nome: e.target.value })
              setValid(canSubmit({ ...data, nome: e.target.value }))
            })}
          />
        </div>

        {/* CPF */}
        <div className="form-field-group">
          <MandatoryField title='CPF:' />
          <input type="text" name="cpf" className="form-text"
            value={data.cpf ? data.cpf : ''}
            disabled={true}
            onChange={() => { }}
          />
        </div>

        {/* RG */}
        <div className="form-field-group">
          <MandatoryField title='RG:' />
          <input type="text" name="rg" className="form-text"
            value={data.rg ? data.rg : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   rg: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ rg: e.target.value })
              setValid(canSubmit({ ...data, rg: e.target.value }))
            })}
          />
        </div>

        <div className="form-field-group">
          <MandatoryField title='Data de nascimento:' />
          <MaskedInput
            // style={{border: 0, flex: 0}}
            // disabled={this.state.loading}
            value={!!data.nasc ? data.nasc : ''}
            placeholder={'__/__/____'}
            mask={
              [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
            }
            onChange={((e) => {
              let value = e.target.value
              if (!value) { value = '' }
              if (value === '__/__/____') {
                value = ''
              } else {
                value = value.replace(/[_]/g, '')
              }
              // let formData = {
              //   ...data,
              //   nascValue: moment(value, 'DD/MM/YYYY').valueOf(),
              //   nasc: value
              // }
              // this.setState({formData})
              props.setForm({
                nascValue: moment(value, 'DD/MM/YYYY').valueOf(),
                nasc: value
              })
              setValid(canSubmit({ ...data, nasc: e.target.value }))
            })}


            onBlur={((e) => {
              // e.preventDefault()
              let value = e.target.value.replace(/[_]/g, '')

              console.log('BLURRING', value)
              if (value.length < 10) {
                // let formData = {
                //   ...data,
                //   nasc: ''
                // }
                // this.setState({formData: o})
                props.setForm({ nasc: '' })
              }
            })}
            className="form-text"
          />
          {!!data.nasc && data.nasc.length === 10 && (
            isDateValid(data.nasc) ? (
              // <InlineIcon icon={checkIcon} width={20} style={{color: 'green'}} />
              <div></div>
            ) : (
              // <InlineIcon icon={alertIcon} width={20} style={{color: 'red'}} />
              <div className="login-error">Data inválida</div>
            )
          )}

        </div>
        <div className="form-field-group">
          <MandatoryField title='E-mail:' />
          <input type="email" name="e-mail" className="form-text"
            value={data.email ? data.email : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   email: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ email: e.target.value })
              setValid(canSubmit({ ...data, email: e.target.value }))
            })}
          />
        </div>
        <div className="form-field-group">
          <MandatoryField title='Telefone:' />
          <MaskedInput
            // disabled={this.state.loading}
            value={!!data.tel ? data.tel : ''}
            placeholder={'(__) _____-____'}
            // placeholderChar={' '}
            // guide={false}
            mask={
              makeTelMask(!!data.tel ? data.tel : '')
            }
            onChange={((e) => {
              let value = e.target.value
              if (!value) { value = '' }
              if (value === '(__) _____-____') {
                value = ''
              } else {
                value = value.replace(/[_]/g, '')
              }
              // let formData = {
              //   ...data,
              //   tel: value
              // }
              // console.log(owner)
              // this.setState({formData})
              props.setForm({ tel: value })
              setValid(canSubmit({ ...data, tel: value }))
            })}
            className="form-text"
          />

        </div>


        {/* Sexo */}
        <div className="form-field-group">
          Como você se identifica?
          <select name="sexo" className="form-text"
            value={data.sexo ? data.sexo : '-'}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   sexo: e.target.value
              // }
              props.setForm({ sexo: e.target.value })
            })}>
            <option value="-"></option>
            <option value="homem">Homem</option>
            <option value="mulher">Mulher</option>
            <option value="homem trans">Homem Trans</option>
            <option value="mulher trans">Mulher Trans</option>
            <option value="não binário">Não binário</option>
          </select>
        </div>

        {/*
  Indicação
*/}
        <div className="form-field-group">
          Como conheceu a Mania de Eventos?
          <select name="comoConheceu" className="form-text"
            value={data.comoConheceu ? data.comoConheceu : '-'}
            onChange={((e) => {
              let comoConheceu = e.target.value
              let comoConheceuDetalhes = ''
              switch (e.target.value) {
                case 'site':
                case 'facebook':
                case 'instagram':
                  comoConheceuDetalhes = ''
                  break
                case 'indicacao':
                  comoConheceuDetalhes = data.comoConheceuDetalhes
                  // this.setState({indicacaoText: 'Quem?'})
                  break
                default:
                  comoConheceuDetalhes = data.comoConheceuDetalhes
                  // this.setState({indicacaoText: 'Especifique:'})
                  break
              }
              // let formData = {
              //   ...data,
              //   comoConheceu,
              //   comoConheceuDetalhes
              // }
              // this.setState({formData})
              props.setForm({ comoConheceu, comoConheceuDetalhes })
            })}
          >
            <option value='-'></option>
            <option value='site'>Site</option>
            <option value='facebook'>Facebook</option>
            <option value='instagram'>Instagram</option>
            <option value='indicacao'>Indicação</option>
            <option value='outros'>Outros</option>
          </select>

          {(data.comoConheceu === 'indicacao' || data.comoConheceu === 'outros') &&
            (
              <div className="form-sub-field">
                {data.comoConheceu === 'indicacao' ? 'Quem?' : 'Especifique:'} <input type="text" className="form-text"
                  // style={{marginLeft: '8px'}}
                  value={data.comoConheceuDetalhes || ''}
                  onChange={((e) => {
                    // let formData = {
                    //   ...data,
                    //   comoConheceuDetalhes: e.target.value
                    // }
                    props.setForm({ comoConheceuDetalhes: e.target.value })
                    // this.setState({formData})
                  })}
                />
              </div>
            )
          }


          {/* Contato de emergência */}
          <div className="form-contato-group">
            <div className="form-header" style={{ textAlign: 'center', marginTop: '8px', marginBottom: '16px' }}>Contato de emergência</div>

            {/* Nome */}
            <div className="form-field-group">
              Nome:
              <input type="text" name="emerg-nome" className="form-text"
                value={data.contatoEmergenciaNome ? data.contatoEmergenciaNome : ''}
                onChange={((e) => {
                  // let formData = {
                  //   ...data,
                  //   nome: e.target.value
                  // }
                  // this.setState({formData})
                  props.setForm({ contatoEmergenciaNome: e.target.value })
                })}
              />
            </div>

            {/* Telefone */}
            <div className="form-field-group">
              Telefone:
              <MaskedInput
                value={!!data.contatoEmergenciaTel ? data.contatoEmergenciaTel : ''}
                placeholder={'(__) _____-____'}
                mask={
                  makeTelMask(!!data.contatoEmergenciaTel ? data.contatoEmergenciaTel : '')
                }
                onChange={((e) => {
                  let value = e.target.value
                  if (!value) { value = '' }
                  if (value === '(__) _____-____') {
                    value = ''
                  } else {
                    value = value.replace(/[_]/g, '')
                  }
                  props.setForm({ contatoEmergenciaTel: value })
                })}
                className="form-text"
              />

            </div>

            {/* Parentesco */}
            <div className="form-field-group">
              Grau de parentesco/relação:
              <input type="text" name="emerg-grau" className="form-text"
                value={data.contatoEmergenciaGrau ? data.contatoEmergenciaGrau : ''}
                onChange={((e) => {
                  props.setForm({ contatoEmergenciaGrau: e.target.value })
                })}
              />
            </div>




          </div>


        </div>



        <div className="form-send-row">
          <button
            // onClick={() => history.goBack()}
            // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            className="login-button"
            onClick={() => props.onPrev()}
          >{`${'< Voltar'}`}
          </button>
          <button
            // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            className="login-button"
            disabled={!valid}
            // disabled={canSubmit(props.formData)}
            onClick={() => props.onNext()}
          >{`${'Continuar >'}`}</button>
        </div>
        {/* {
!!this.state.error &&
<div className="login-error">{this.state.error}</div>
} */}
      </form>
    </>
  )
}

export default FormPage1
